import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { EditDashboardViewRPC } from "./editDashboardViewRPC";

export class EditDashboardViewRPCClientImpl extends EditDashboardViewRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: EditDashboardViewRPC.Request): Promise<LeoRPCResult<EditDashboardViewRPC.Response, EditDashboardViewRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/EditDashboardView",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      EditDashboardViewRPC.ResponseDTO,
      EditDashboardViewRPC.Errors.ErrorsDTO,
      EditDashboardViewRPC.Response,
      EditDashboardViewRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/EditDashboardView",
      EditDashboardViewRPC.Response.fromDTO,
      EditDashboardViewRPC.Errors.fromDTO
    );
  }
}
